<template>
    <div class="headers">
      <div class="container top-info">
        <div class="content">
          <p class="welcome">合美月子中心，欢迎您的光临！</p>
          <div class="t-i-r">
            <p class="consult"><span class="iconfont">&#xe619;</span>咨询热线：0519-86957666</p>
            <span class="iconfont voice">&#xe654;</span>
            <div class="marquee">
              <div class="marquee_box">
                <ul class="marquee_list" :class="{marquee_top:animate}">
                  <li v-for="item in marqueeList" :key='item.id'>
                    {{item.content}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container nav">
        <div class="content">
          <h1>常州合美月子中心</h1>
          <router-link to="/" class="logo" title="常州合美月子中心">
            <img src="../../../static/img/logo.png"  alt="常州合美月子中心-logo">
          </router-link>
          <div class="nav-box">
            <ul>
              <router-link :to="item.src" class="nav-item"
                           tag="li" v-for="item in navList" :key="item.id">
                {{item.name}}
                <div class="hide-box" v-if="item.cate">
                  <ul>
                    <router-link tag="li" :to="iitem.link" class="sec-cate"
                                 v-for="iitem in item.cate" :key="iitem.id">
                      {{iitem.name}}
                    </router-link>
                  </ul>
                </div>
              </router-link>
              <router-link to='/dynamic' class="nav-item">
                最新动态
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "header",
      data(){
          return{
            animate: false,
            navList:[
              {
                id:'f1',
                name:"首页",
                src:'/'
              },
              {
                id:'f2',
                name:"关于合美",
                src:'/about/story',
                cate:[
                  {
                    name:'品牌故事',
                    id:1,
                    link:'/about/story'
                  },
                  {
                    name:'专家团队',
                    id:2,
                    link:'/about/team'
                  },
                  {
                    name:'联系我们',
                    id:3,
                    link:'/about/us'
                  },
                ]
              },

              {
                id:'f4',
                name:"月子套餐",
                src:'/setmeal'
              },
              {
                id:'f3',
                name:"六大服务",
                src:'/describe'
              },
              {
                id:'f5',
                name:"合美特色",
                src:'/advantage'
              },
              {
                id:'f6',
                name:"口碑见证",
                src:'/praise'
              }

            ],
            newL:[
              {
                id:1,
                name:'月子科普'
              },
              {
                id:2,
                name:'合美资讯'
              },
              {
                id:3,
                name:'优惠活动'
              },

            ],
            marqueeList: [
              {
                id:1,
                content: '提示：房型紧，预定需提前1-2个月',
              },
              {
                id:2,
                content: '提示：房型紧，预定需提前1-2个月',
              },
              {
                id:3,
                content: '提示：房型紧，预定需提前1-2个月',
              },
              {
                id:4,
                content: '提示：房型紧，预定需提前1-2个月',
              }
            ]
          }
      },
      created: function () {
        setInterval(this.showMarquee, 2000)
      },
      methods: {
        pathTo:function(id){
          this.$router.push({
            path: `/dynamic/${id}`,
          })
        },
        changeActive:function(e){
          this.$store.state.nav = e
        },
        showMarquee: function () {
          this.animate = true;
          setTimeout(()=>{
            this.marqueeList.push(this.marqueeList[0]);
            this.marqueeList.shift();
            this.animate = false;
          },1500)},
      }

    }
</script>

<style scoped lang="less">
.headers{
  .top-info{
    height: 38px;
    background-color: #906236;
    color:#f0f0f0;
    .content{
      line-height: 38px;
      .welcome{
        display: inline-block;
      }
      .t-i-r{
        float: right;
        display: flex;
        .consult{
          display: inline-block;
          vertical-align: middle;
          .iconfont{
            margin-right: 5px;
          }
        }
        .voice{
          margin-left: 10px;
          float: left;
        }
      }
    }
  }
  .nav{
    height: 103px;
    padding: 20px 0;
    .logo{
      display: inline-block;
      img{
        width: 200px;
        height: 63px;
      }
    }
    .nav-box{
      float: right;
      ul{
        .nav-item{
          position: relative;
          cursor: pointer;
          float: left;
          height: 63px;
          padding: 0 20px;
          font-size: 16px;
          line-height: 63px;
          &:hover{
            color:#C2874E;
            .hide-box{
              display: block;
            }
          }
          .hide-box{
            position: absolute;
            z-index: 9999;
            display: none;
            left: -5px;
            .sec-cate{
              height: 50px;
              width: 114px;
              background-color: #c2874e;
              text-align: center;
              color:#ffffff;
              line-height: 50px;
              border-bottom: 1px solid #fff;
              &:hover{
                background-color: #c7925e;
              }
            }
          }
        }
        .nav-item.active{
          background-color: #eca43d;
          color:#ffffff;
        }
      }
    }
    .content{
      position: relative;
      h1{
        position: absolute;
        left: 99999px;
      }
    }
  }
}
.marquee {
  line-height: 40px;
  display: inline-block;
  height: 40px;
  align-items: center;
  box-sizing: border-box;
}

.marquee_box {
  width: 260px;
  display: block;
  position: relative;
  height: 40px;
  overflow: hidden;
}

.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
.marquee_top {
  transition: all 0.5s;
  margin-top: -40px
}

.marquee_list li {
  width: 260px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding-left: 5px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.marquee_list li span {
  padding: 0 2px;
}

.red {
  color: #FF0101;
}

</style>



// WEBPACK FOOTER //
// src/components/public/header.vue